module.exports = __webpack_public_path__ + "img/skjqrxt.52b3daa8.jpg";